module.exports = __webpack_public_path__ + "static/media/LogoClpDesktop.45dc91ce.svg";